// extracted by mini-css-extract-plugin
export var container = "_40-1";
export var cornerButtonContainer = "_40-5";
export var disabled = "_40-2";
export var fileContainer = "_40-4";
export var hiddenInput = "_40-3";
export var widthContainer = "_40-0";